import React, { useRef } from "react";
import tw from "twin.macro";
import AiCollaborationFeature from "./AiCollaborationFeature";
import AiPromptAction from "./AiPromptAction";
import { getAdvantagesPrompt, getInstallPrompt } from "./aiPrompts";

// J-Marketing-27 / S-Marketing-21 (Q-Marketing-51 O-1): the page opens the
// progression story. The hero states the pitch's claim with no competing visual;
// Act 1 is use case one — plan and organize the work you do with AI — carried by
// the existing feature-list animation, with the MCP/CLI story compressed to a
// slim row inside the act (the standalone CLIFeature section left the page).
// The onboarding steps and deeper walkthrough moved to DeeperTour below the
// pricing epilogue (placement pending Q-Marketing-52).

const TextContent = tw.div`pt-24 text-center md:text-left`;
const Heading = tw.h1`font-black text-4xl lg:text-6xl text-center leading-tight font-sans pb-0 pt-3 tracking-tight`;
const SubHeading = tw.p`text-center font-sans text-lg lg:text-2xl text-gray-600 mt-5 mb-0`;
const PromptActions = tw.div`grid grid-cols-2 gap-3 max-w-2xl mx-auto px-6`;
// S-Marketing-24: tiny uppercase eyebrows carry the story arc across the acts.
const ActEyebrow = tw.div`font-sans text-sm font-bold tracking-widest uppercase text-blue-600 text-center mt-12 mb-0`;

const AboveTheFold = (properties) => {
    const { isMobile } = properties;
    const refToTop = useRef();
    const deskTopWidth = '72rem';
    const installPrompt = getInstallPrompt(window.location.hostname);

    return (
        <TextContent ref={refToTop} style={{paddingTop: isMobile ? '50px' : undefined}}>
            <Heading style={{maxWidth: isMobile ? '24rem' : deskTopWidth, marginLeft: 'auto', marginRight: 'auto', paddingLeft: 48, paddingRight: 48}}>
                Communicate like a machine
            </Heading>
            {/* B-Marketing-5: the subhead gives the tagline its reason (your collaborators
                are machines) before naming and defining the product. */}
            <SubHeading style={{maxWidth: isMobile ? '24rem' : '50rem', marginLeft: 'auto', marginRight: 'auto', paddingLeft: 24, paddingRight: 24}}>
                in a structured workspace where AI asks your opinion and stores context. The only complete human-in-the-loop planning solution.
            </SubHeading>

            <PromptActions>
                <AiPromptAction label="Have AI install" prompt={installPrompt} />
                <AiPromptAction label="Have AI demo" prompt={getAdvantagesPrompt(window.location.hostname)} />
            </PromptActions>
            <ActEyebrow>Today: get out of chat</ActEyebrow>
            <AiCollaborationFeature isMobile={isMobile} />
        </TextContent>
    );
};

export default AboveTheFold;
